import { render, staticRenderFns } from "./TaskTimerDock.vue?vue&type=template&id=127c0acb&scoped=true"
import script from "./TaskTimerDock.vue?vue&type=script&lang=js"
export * from "./TaskTimerDock.vue?vue&type=script&lang=js"
import style0 from "./TaskTimerDock.vue?vue&type=style&index=0&id=127c0acb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c0acb",
  null
  
)

export default component.exports